"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.slice.js");
var _utils = require("../utils");
var _use = (0, _utils.use)('marquee'),
  sfc = _use[0];
var _default = sfc({
  data: function data() {
    return {
      height: 0,
      length: 0,
      currentIndex: 0,
      timer: null
    };
  },
  props: {
    hiddenStop: {
      type: Boolean,
      default: true
    },
    showLength: {
      type: Number,
      default: 1
    },
    interval: {
      type: Number,
      default: 3000 // ms
    },

    duration: {
      type: Number,
      default: 600 // ms
    },

    direction: {
      validator: function validator(val) {
        return val === 'up' || val === 'down';
      },
      default: 'up'
    }
  },
  computed: {
    shouldScroll: function shouldScroll() {
      return this.length > this.showLength;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.$refs.container) {
      this.fixList();
    }
    if (this.hiddenStop) {
      window.addEventListener('visibilitychange', function () {
        return document.hidden === true ? _this.stop() : _this.start();
      });
    }
  },
  activated: function activated() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.shouldScroll && !_this2.timer && _this2.start();
    });
  },
  deactivated: function deactivated() {
    clearInterval(this.timer);
    this.timer = null;
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    reset: function reset(toFirst) {
      var _this3 = this;
      if (toFirst === void 0) {
        toFirst = false;
      }
      var length = this.$refs.container.childNodes.length;

      // 删除组件之前添加的元素
      if (this.shouldScroll) {
        for (var i = 0; i < this.showLength; i++) {
          var index = this.direction === 'up' ? length - i - 1 : i;
          this.$refs.container.childNodes[index] && this.$refs.container.childNodes[index].remove();
        }
      }
      this.$nextTick(function () {
        clearInterval(_this3.timer);
        _this3.timer = null;
        if (toFirst) {
          _this3.quickJump(true);
        }
        _this3.fixList();
      });
    },
    /*
      * 根据方向将第一个或最后一个item复制添加到列表最后或前面，保证下一次轮播连贯
      * 将单个item高度设置为广播视窗高度
      */
    fixList: function fixList() {
      var _this4 = this;
      var cloneNode;
      var childs = [].slice.apply(this.$refs.container.childNodes);
      // 根据item高度设置视窗container高度
      this.length = this.$refs.container.children.length;
      if (this.shouldScroll) {
        if (this.direction === 'up') {
          for (var i = 0; i < this.showLength; i++) {
            var item = childs[i];
            if (item) {
              cloneNode = item.cloneNode(true);
              this.$refs.container.appendChild(cloneNode);
            }
          }
        } else {
          for (var _i = this.length - 1; _i >= this.length - this.showLength; _i--) {
            var _item = childs[_i];
            if (_item) {
              cloneNode = _item.cloneNode(true);
              this.$refs.container.insertBefore(cloneNode, this.$refs.container.children[0]);
            }
          }
        }
        this.$nextTick(function () {
          // 用总高度/length，减小较小
          _this4.height = _this4.$refs.container.offsetHeight / (_this4.length + _this4.showLength);
          _this4.start();
        });
      } else {
        (0, _utils.setTransform)(this.$refs.container, 'translateY(0)');
      }
    },
    stop: function stop() {
      clearInterval(this.timer);
    },
    /*
      * 启动轮播
      */
    start: function start() {
      var _this5 = this;
      var currenTransitionTime;
      var currenTranslateY;
      // 方向向下，列表初始时跳转到最后item
      if (this.direction === 'down') this.quickJump(false);
      this.timer = setInterval(function () {
        if (_this5.direction === 'up') {
          _this5.currentIndex += 1;
        } else {
          _this5.currentIndex -= 1;
        }
        // 正常轮播transition时间为用户设置duration时间
        currenTransitionTime = 'transform ' + _this5.duration + 'ms ease-in-out 0.1s';
        // eslint-disable-next-line no-undef
        (0, _utils.setTransition)(_this5.$refs.container, currenTransitionTime);
        // 正常轮播每次currenTranslateY增加一个item高度
        if (_this5.direction === 'up') {
          currenTranslateY = -_this5.currentIndex * _this5.height + 'px';
        } else {
          currenTranslateY = -(_this5.currentIndex + 1) * _this5.height + 'px';
        }
        (0, _utils.setTransform)(_this5.$refs.container, "translateY(" + currenTranslateY + ")");
        // 当滑动到首尾边界替补item时，需即刻跳转到正确item位置
        if (_this5.currentIndex === _this5.length) {
          setTimeout(function () {
            _this5.quickJump(true);
          }, _this5.duration);
        } else if (_this5.currentIndex === -1) {
          setTimeout(function () {
            _this5.quickJump(false);
          }, _this5.duration);
        }
        _this5.onChange();
      }, this.interval + this.duration);
    },
    // 暴露当前滚动的索引
    onChange: function onChange() {
      var index = this.currentIndex < 0 ? this.length - 1 : this.currentIndex < this.length ? this.currentIndex : 0;
      this.$emit('change', index);
    },
    /*
      * 设置transition 0ms，再设置translatet位置启动跳转
      * 由于跳转前后展现的内容完全一样，肉眼看不到跳转过程
      */
    quickJump: function quickJump(toFirst) {
      var currenTranslateY;
      var currenTransitionTime = 'transform 0ms ease-in-out';
      (0, _utils.setTransition)(this.$refs.container, currenTransitionTime);
      if (toFirst) {
        // 跳转到首个item
        this.currentIndex = 0;
        currenTranslateY = '0px';
      } else {
        this.currentIndex = this.length - 1;
        currenTranslateY = -(this.currentIndex + 1) * this.height + 'px';
      }
      (0, _utils.setTransform)(this.$refs.container, "translateY(" + currenTranslateY + ")");
    }
  },
  render: function render(h) {
    return h("div", {
      "class": "z-marquee"
    }, [h("div", {
      "class": "z-marquee-container",
      "ref": "container"
    }, [this.slots()])]);
  }
});
exports.default = _default;